import React from "react";
import ClearIcon from "@mui/icons-material/Clear";
import hexToRGB from "utils/hexToRGB";
import { styled, useTheme } from "@mui/material";

const StyledButton = styled("button")(({ theme }) => ({
    margin: 0,
    backgroundColor: "transparent",
    // color: theme.palette.secondary.main,
    flexBasis: "auto",
    border: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: hexToRGB(theme.palette.primary.main, 0.1),
    },
}));

interface AcxFileButtonProps {
    className?: string;
    onClick: () => void;
}
export default function AcxRemoveFileButton(props: AcxFileButtonProps) {
    const theme = useTheme();
    const handleVectorEvents = (e: React.MouseEvent) => {
        if (props.onClick) {
            props?.onClick();
        }
        e.stopPropagation();
    };
    function FileListIcon(props) {
        return (
            <ClearIcon
                onClick={handleVectorEvents}
                {...props}
                sx={{ color: theme.palette.secondary.main, fontSize: "16px" }}
            />
        );
    }
    return (
        // <IconButton className={classes.button} color="secondary" onClick={props?.onClick}><FileListIcon fontSize={'small'} /></IconButton>
        <StyledButton onClick={props?.onClick}>
            <FileListIcon fontSize={"small"} />
        </StyledButton>
    );
}
